export const base_url = "https://lm6hh9bbmf.execute-api.ap-south-1.amazonaws.com/dev/api/"